import React, { Component } from 'react';
import { cloneDeep } from 'lodash';

import analyticService from '../../services/analytics';
import { dateService } from '../../services/date';

import { Networks } from './megatable/models';
import megatableService from './megatable/megatable-service';
import StatTable from './megatable/stat-table';
import { Loader, NoResult } from '../misc/loader-utils';

import narrativLogo from '../../images/logos/narrativ_text_2.svg';

import articlePopular from '../../images/img-article-popular.png';
import articleDestress from '../../images/img-article-destress.png';
import articleWfh from '../../images/img-article-wfh.png';
import articleKids from '../../images/img-article-kids.png';
import articleTableMdm from '../../images/article-table-medium-condensed.png';

import graph from '../../images/graph_2.png';
import trendingProductsPlotted from '../../images/img-trending-products-plotted.png';
import trendingProductsRow from '../../images/img-trending-products-row.png';

import './article-search.scss';

class ArticleSearch extends Component {
  constructor(props) {
    super(props);

    this.AnalyticService = analyticService;
    this.MegatableService = megatableService;

    this.statType = 'article';

    // MVP is a static page, set static to false to run stats query and load table
    this.static = true;

    this.state = {
      // State variables
      loading: true,
      showNoResult: false,
      // Query params
      params: {
        date_from: '2015-07-01', // When we start collecting stats
        date_to: dateService.formatDate(dateService.getCurrentDateTime()),
        order_by: 'clicks',
        direction: 'desc',
      },
      // Stats params
      stats: {},
      // Pagination variables
      page: 1,
      perPage: 10,
      // Dropdown variables
      networks: new Networks(this.statType).defaultNetworks.slice(),
      // Email capture variables
      email: '',
      warning: '',
      captured: false,
    };
  }

  componentDidMount() {
    if (!this.static) this.queryStats(true);
  }

  queryStats(resetSearch = false) {
    this.setState({
      loading: true,
    });

    // Translate the state params into params for the API request
    const params = cloneDeep(this.state.params);

    const networkStr = this.MegatableService.getNetworkString(this.state.networks);
    if (networkStr) params.networks = networkStr;

    // If a param is null, remove it from the API request params
    Object.keys(params).forEach(key => {
      if (params[key] === null || params[key] === 'null') {
        delete params[key];
      }
    });

    // If pubId is null, endpoint queries stats for all publishers
    const pubId = null;

    /*
     * TODO: API service requestInterceptor assigns headers.Authorization
     * Add new backend endpoint that does not require authentication.
     */
    return this.MegatableService.getStats(
      pubId,
      this.statType,
      this.state.page,
      this.state.perPage,
      params,
      resetSearch,
    )
      .then(({ stats }) => {
        return this.setState({
          stats,
          showNoResult: !stats.length,
        });
      })
      .then(() => {
        return this.setState({ loading: false });
      });
  }

  handleFormChange(event) {
    const emailRegex = /\S+@\S+\.\S+/; // checks for string@string.string
    let warning = '';

    if (!event.target.value) {
      warning = 'This field is required.';
    } else if (!emailRegex.test(event.target.value)) {
      warning = 'Please enter a valid email address.';
    } else {
      warning = '';
    }

    this.setState({
      warning,
      email: event.target.value,
    });
  }

  async captureEmail() {
    this.AnalyticService.trackEvent('Article Search', 'input', 'Email Capture', {
      email: this.state.email,
    });

    const delayedState = setTimeout(() => {
      this.setState({ email: '', captured: true }, clearTimeout(delayedState));
    }, 500);
  }

  render() {
    const mcSignupForm = label => {
      return this.state.captured ? (
        <p className="confirmation-text">Thanks, our team will get back to you soon.</p>
      ) : (
        <>
          <div id="mc_embed_signup" className="email-capture-form">
            <form
              action="https://narrativ.us19.list-manage.com/subscribe/post?
											u=c25dc6dc2a21e7cbd3f0a6f9e&amp;id=c3d2799095"
              method="post"
              id="mc-embedded-subscribe-form"
              name="mc-embedded-subscribe-form"
              className="validate"
              target="_blank"
              noValidate={true}
            >
              <div id="mc_embed_signup_scroll" className="capture-container">
                <div className="input-field-container mc-field-group">
                  <input
                    type="email"
                    name="EMAIL"
                    id="mce-EMAIL"
                    className="email-input required email"
                    placeholder="Email Address"
                    value={this.state.email}
                    onChange={this.handleFormChange.bind(this)}
                  />
                </div>
                <div id="mce-responses" className="clear">
                  <div className="response" id="mce-error-response" style={{ display: 'none' }} />
                  <div className="response" id="mce-success-response" style={{ display: 'none' }} />
                </div>
                <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
                  <input
                    type="text"
                    name="b_c25dc6dc2a21e7cbd3f0a6f9e_c3d2799095"
                    tabIndex="-1"
                    placeholder=""
                  />
                </div>
                <div className="button-container clear">
                  <input
                    type="submit"
                    name="subscribe"
                    id="mc-embedded-subscribe"
                    className="button"
                    value={label}
                    onClick={this.captureEmail.bind(this)}
                    disabled={!this.state.email || this.state.warning}
                  />
                </div>
              </div>
            </form>
          </div>
          <p className="warning">{this.state.warning}</p>
        </>
      );
    };

    const table = !this.static ? (
      <>
        <Loader loading={this.state.loading} />
        <NoResult
          type={`megatable-${this.statType}s`}
          noResult={!this.state.loading && this.state.showNoResult}
        />
        {!this.state.loading && !this.state.showNoResult ? (
          <StatTable
            stats={this.state.stats}
            statType={this.statType}
            sortOptions={this.state.params}
            history={this.props.history}
            match={this.props.match}
            location={this.props.location}
          ></StatTable>
        ) : null}
      </>
    ) : (
      <img className="graph" src={articleTableMdm} title="Articles table" alt="" />
    );

    const trendingCarousel = (
      <>
        <img className="product-collage" src={articlePopular} title="Popular Articles" alt="" />
        <div className="mobile">
          <img
            className="product"
            src={articleDestress}
            title="Top 10 Ways to De-Stress After Work"
            alt=""
          />
          <img
            className="product"
            src={articleWfh}
            title="How To Stay Sane While Working From Home"
            alt=""
          />
          <img
            className="product"
            src={articleKids}
            title="These 50 Fun Activites For Kids Will Keep Them Entertained For Hours"
            alt=""
          />
        </div>
        {table}
      </>
    );

    const trendingProducts = (
      <>
        <img
          className="graph-products"
          src={trendingProductsPlotted}
          title="Trending Products"
          alt=""
        />
        <img
          className="mobile graph-products"
          src={trendingProductsRow}
          title="Trending Products"
          alt=""
        />
      </>
    );

    return (
      <div className="article-search">
        <div className="header">
          <div className="logo">
            <a className="home" href="https://narrativ.com">
              <img
                src={narrativLogo}
                title="Narrativ"
                alt="Narrativ is the first real-time exchange for premium publisher content."
              />
            </a>
          </div>
        </div>

        <div className="banner-1">
          <div className="container">
            <p className="primary-text">Who's talking about your products right now?</p>
            <div className="line-break" />
            <p className="secondary-text">
              The world is changing fast. Our data shows you which products are trending in real
              time.
            </p>
            <div className="email-capture">{mcSignupForm("I'm Interested")}</div>
          </div>
        </div>

        <div className="trending-content">
          <div className="container">
            <p className="primary-text">
              Check out the most popular articles recommending your products
            </p>
            <div className="line-break" />
            <div className="carousel trending-carousel">{trendingCarousel}</div>
          </div>
        </div>

        <div className="banner-2">
          <div className="container">
            <p className="primary-text">What products do shoppers need right now?</p>
            <div className="line-break" />
            <p className="secondary-text">
              Shoppers are making smart decisions with help from trusted experts
            </p>
            <img className="graph-points" src={graph} title="Trending Products Graph" alt="" />
            <div className="trending-graph">{trendingProducts}</div>
          </div>
        </div>

        <div className="results-content">
          <div className="container">
            <p className="primary-text">The results</p>
            <div className="line-break" />
            <div className="carousel results-carousel">
              <div className="results-card">
                <div className="primary-text">71% new customers</div>
              </div>
              <div className="results-card">
                <div className="primary-text">guaranteed ROAS</div>
              </div>
              <div className="results-card">
                <div className="primary-text">sem-sized revenue</div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer">
          <div className="container">
            <div className="footer-content">
              <p className="secondary-text">
                Interested in turning product recommendations into revenue?
              </p>
              <div className="email-capture">
                <p className="primary-text">Contact our team directly:</p>
                {mcSignupForm('Sign Up')}
              </div>
            </div>
            <div className="line-break" />
            <p className="copyright">
              Copyright © 2020 The Narrativ Company, Inc. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default ArticleSearch;
